module.exports = require('./lib/no-important.js');



//////////////////
// WEBPACK FOOTER
// ./~/aphrodite/no-important.js
// module id = 100
// module chunks = 0